import React, { useState, useEffect, useRef } from 'react';
import ContentEditable from 'react-contenteditable';

interface Props {
    text: string;
    placeholder?: string;
    showToolBar?: boolean;
    optionsFormatedType: any;
    mentions?: any
    userMention: Function,
    removeMention?: Function
    selectedMentions?: any
    removedMention?: any
    refreshRemoved?: Function
    setText: Function
}

const ScriptEditor: React.FC<Props> = (props) => {
    const [text, setText] = useState(props.text || "");
    const [focused, setFocused] = useState(false);
    const [replacedUser, setReplacedUser] = useState<string>("")
    const editorRef: any = useRef(null);

    useEffect(() => {
        if (text === '') {
            setText(props.placeholder || '');
        }
    }, []);

    useEffect(() => {
        setText(props.text || "");
    }, [props.text]);

    useEffect(() => {
        if (props.selectedMentions && props.selectedMentions.length > 0 && text) {
            const mentionName = props.selectedMentions[0].name;
            const mentionId = props.selectedMentions[0].id;
            let string = text;
            let stringToReplace = `<strong data-mention-id="${mentionId}">${mentionName.toLowerCase()}</strong>&nbsp`;
            let newString = string.replace(replacedUser, stringToReplace);
            setText(newString);
        }
    }, [props.selectedMentions]);

    useEffect(() => {
        if (props.removedMention && text) {
            removeMention();
        }
    }, [props.removedMention]);

    const removeMention = (userLocal?: any) => {
        let string = text;
        let replacedString = `<strong data-mention-id="${props.removedMention.id}">${(props.removedMention.name).toLowerCase()}</strong>`;

        if (string.includes(replacedString)) {
            // let newString = string.replace(replacedString, (props.removedMention.name).toLowerCase());
            let newString = string.replace(replacedString, ("").toLowerCase());
            setText(newString);
        }

        props.refreshRemoved && props.refreshRemoved(undefined);
    }

    useEffect(() => {
        document.execCommand('bold', false, props.optionsFormatedType.bold);
    }, [props.optionsFormatedType.bold]);

    useEffect(() => {
        document.execCommand('italic', false, props.optionsFormatedType.italic);
    }, [props.optionsFormatedType.italic]);

    useEffect(() => {
        document.execCommand('strikeThrough', false, props.optionsFormatedType.strikeThrough);
    }, [props.optionsFormatedType.strikeThrough]);

    const handleChange = (e) => {
        const inputType = e.nativeEvent.inputType;

        let texto = e.target.value;

        // if (inputType === "insertFromPaste") {
        //     texto = texto.replace(/<[^>]*>/g, '')
        // }

        // if ((inputType === "insertFromPaste") && e.target.value.includes("<img ")) {
        //     return;
        // }

        props.mentions.forEach(user => {
            for (let index = user.name.length; index > 0; index--) {
                var teste = user.name.slice(0, index);

                if (texto.includes(`<strong data-mention-id="${user.id}">${teste.toLowerCase()}</strong>`) && teste.length <= 4) {
                    user.name = teste;
                    props.removeMention && props.removeMention(user, "mention");
                }
            }
        });

        setText(texto);
        props.setText(texto);
    };

    const handleFocus = () => {
        if (text === (props.placeholder || '')) {
            setText('');
        }

        setFocused(true);
    };

    const handleBlur = () => {
        setFocused(false);
    };

    const handleUserMention = (e: any) => {
        if (e.target.innerText.indexOf("@") >= 0 && e.target.keyCode !== 32) {
            let userName = e.target.innerText.slice(e.target.innerText.indexOf("@") + 1);
            let userToReplace = e.target.innerText.slice(e.target.innerText.indexOf("@")).trimEnd();
            setReplacedUser(userToReplace);
            props.userMention && props.userMention(userName.includes(".com") ? "" : userName);
        }
    }

    const pasteImage = async (event) => {
        const items = (event.clipboardData || event.originalEvent.clipboardData).items;

        for (let i = 0; i < items.length; i++) {
            if (items[i].type.indexOf('image') !== -1) {
                event.preventDefault();
                return;
            }
        }
    }

    return (
        <ContentEditable
            innerRef={editorRef}
            html={text}
            onChange={handleChange}
            tagName={"div"}
            className={"editor-content"}
            onFocus={handleFocus}
            onBlur={handleBlur}
            contentEditable={!focused}
            onKeyUp={handleUserMention}
            onPaste={pasteImage}
            style={{
                color: (text === props.placeholder) ? '#bababa' : '#000',
                height: '100%',
                display: (!props.showToolBar) ? 'flex' : "inherit",
                alignItems: 'center',
                fontSize: '13.3333px'
            }}
        />
    );
};

export default ScriptEditor;